<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Keluhan</h5>
                <b-row class="mt-3">
                    <b-col md="12" lg="12">
                        <div>{{ dataRM.anamnesa.keluhan || '-' }}</div>
                    </b-col>
                </b-row>
                <h5 class="font-weight-bold mt-5">Anamnesa</h5>
                <b-row class="mt-3">
                    <b-col md="12" lg="12">
                        <div v-html="dataRM.anamnesa.notes"></div>
                        <template v-if="dataRM.anamnesa.draw_path !== null">
                            <img :src="dataRM.anamnesa.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3" v-if="poliGigi">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Riwayat Kesehatan</h5>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Penyakit Jantung</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.penyakit_jantung) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Diabetes</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.diabetes) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Haemopilia</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.haemopilia) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Hepatitis</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.hepatitis) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Gastring</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.gastring) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Pengobatan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.penyakit_lainnya, dataRM.diagnosa.ket_penyakit_lainnya) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Alergi & Kondisi Khusus</h5>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Penyakit</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_penyakit || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Alergi Obat</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ alergi.obat || '-' }}
                    </div>
                </div>
                <div class="row" v-if="checkLain('obat')">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Keterangan Riwayat Alergi Obat</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.ket_riwayat_alergi_obat || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Alergi Makanan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ alergi.makanan || '-' }}
                    </div>
                </div>
                <div class="row" v-if="checkLain('makanan')">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Keterangan Riwayat Alergi Makanan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.ket_riwayat_alergi_makanan || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Alergi Udara</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ alergi.udara || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Alergi Lain-lain</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_alergi_lain || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Pengobatan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_pengobatan || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Keterangan Lain</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        <div v-html="dataPasien.keterangan_lain || '-'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import rekamMedisMixin from "../mixins";

    export default {
        name: "Subjective",
        mixins: [rekamMedisMixin],
        props: ["dataRM", "dataPasien", "poliGigi", "pcareVersion"],
        data() {
            return {
                alergi: {
                    makanan: null,
                    udara: null,
                    obat: null,
                }
            }
        },
        computed: {
            ...mapGetters(["getKlinikId"]),
        },
        watch: {
            dataRM() {
                this.buildData();
            }
        },
        mounted() {
            this.buildData();
        },
        methods: {
            convertData(status, content = null) {
                if (status == 'T') {
                    return 'Tidak Ada';
                }
                if (status == 'Y') {
                    if (content) return `Ada, ${content}`;
                    else return 'Ada';
                }
                return '-';
            },
            buildData() {
                if (this.dataRM) {
                    this.setAlergiJenis();
                }
            },
            async setAlergiJenis() {
                if (this.dataRM.anamnesa) {
                    this.alergi.makanan = this.dataRM.anamnesa.riwayat_alergi_makanan;
                    this.alergi.udara = this.dataRM.anamnesa.riwayat_alergi_udara;
                    this.alergi.obat = this.dataRM.anamnesa.riwayat_alergi_obat;
                }
            },
            checkLain(type) {
                if (this.pcareVersion == '1' && this.alergi[type]) {
                    if (this.alergi[type].toLowerCase().includes('lain')) return true;
                }
                return false;
            },
        }
    }
</script>

<style>
    .mb-header {
        margin-bottom: -15px;
    }
</style>